type Point = { x: number; y: number };

/**
 * Quadratic-Bezier smoothing through midpoints.
 * Classic "midpoint smoothing" for freehand strokes — each sampled point becomes
 * a control handle, each segment's endpoints are the midpoints between
 * consecutive samples. Produces a C1-continuous path without Catmull-Rom's
 * tension parameter.
 */
export function smoothedPath(points: Point[]): string {
  if (points.length === 0) return '';
  if (points.length === 1) return `M ${points[0].x} ${points[0].y}`;
  if (points.length === 2) {
    return `M ${points[0].x} ${points[0].y} L ${points[1].x} ${points[1].y}`;
  }

  let d = `M ${points[0].x} ${points[0].y}`;
  const firstMid = midpoint(points[0], points[1]);
  d += ` L ${firstMid.x} ${firstMid.y}`;

  for (let i = 1; i < points.length - 1; i++) {
    const ctrl = points[i];
    const end = midpoint(points[i], points[i + 1]);
    d += ` Q ${ctrl.x} ${ctrl.y} ${end.x} ${end.y}`;
  }

  const last = points[points.length - 1];
  d += ` L ${last.x} ${last.y}`;
  return d;
}

function midpoint(a: Point, b: Point): Point {
  return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
}
